export const AuthVectorSubHeading = () => (
    <h4 className="text-base md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl 3xl:text-[2.125rem] lg:whitespace-pre-line">
        {`Join the vision revolution: Expert-endorsed eye \n exercises to enhance your eyesight – Get started \n today`}
    </h4>
)
